import React from "react";
import {FaArrowDown} from "react-icons/fa";

function DataIngestionHeader () {
    return(
        <div className="container">
            <div className="row">
              <div className="col-10">
                <form action="">
                  <input placeholder="Data Ingesion" className="projectname" />
                </form>
              </div>
              <div className="col-2 subheaderDataInjection">
                < FaArrowDown style={{"fontSize": "36px"}}/> &nbsp;
              <span >
              <form action="">
                  <input
                    type="download"
                    className="AdvanceDataSearchDataHeader"
                    placeholder="Import Sheet"
                  />
                </form>
              </span>
              </div>
              <div className="col-8 dataingestiontitle">
              <span>Shining Towers</span>
              </div>
              <div className="col-4">
                <form action="">
                  <input
                    type="search"
                    className="searchsty"
                    placeholder="Search"
                  />
                </form>
              </div>
            </div>
        </div>
    )
};

export default DataIngestionHeader ;